// ------------------------------------
// Depoimentos (Carrosel)
// ------------------------------------

const depoCarroselClass = '.carousel-depoimentos';

depoInitSlick();

// Desabilita o plugin de carrosel
function depoDestroySlick() {
  const $depoCarrosel = $(depoCarroselClass);
  $depoCarrosel.each(function () {
    const $depoCarroselItem = $(this);
    if ($depoCarroselItem.hasClass('slick-slider')) {
      $depoCarroselItem.slick('unslick');
    }
  });
}

// Aplica o plugin de carrosel
function depoInitSlick() {
  const $depoCarrosel = $(depoCarroselClass);
  $depoCarrosel.each(function () {
    const $depoCarroselItem = $(this);
    if (!$depoCarroselItem.hasClass('slick-initialized')) {
      const dotsEnableLg = $depoCarroselItem.find('.depoimento-wrapper').length > 2;
      const dotsEnableMd = $depoCarroselItem.find('.depoimento-wrapper').length > 2;
      const dotsEnableSm = $depoCarroselItem.find('.depoimento-wrapper').length > 1;
      $depoCarroselItem.slick({
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
        autoplay: false,
        adaptiveHeight: true,
        arrows: false,
        dots: dotsEnableLg,
        // Responsivo
        responsive: [
          // Tablet
          {
            breakpoint: 960,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              dots: dotsEnableMd,
            },
          },
          // Mobile
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: dotsEnableSm,
            },
          },
        ],
      });
    }
  });
}

if (!previewMode) {
  slickReinitLazy($(depoCarroselClass), depoInitSlick, depoDestroySlick);
}
